<template>
  <user-dropdown
    :company-name="companyName"
    :profile-route-path="{ name: 'supplier-details', params: { supplierId } }"
    v-bind="$attrs"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth.js';
import { useSupplierById } from '@/services/suppliers/queries.js';
import UserDropdown from '@/components/user/UserDropdown.vue';

const authStore = useAuthStore();
const supplierId = computed(() => authStore.supplierId);
const { data: supplier } = useSupplierById(supplierId);

const companyName = computed(() => supplier.value?.data?.chain_name || supplier.value?.data?.name);
</script>
